<template>
  <el-container class="myContainer">
    <el-aside width="320px" class="myContainer">
      <FrameForm ref="queryForm" component-param="company_map_query" :parent-data="queryParam"></FrameForm>
    </el-aside>

    <el-main class="myContainer">
      <div id="mapContainer" style="width: 100%;height: 100%"></div>

        <!--
            <baidu-map :center="center" :zoom="5" :double-click-zoom="false"  @ready="handler" class="baidu-map-view" ak="qN6f8luOgorhLZWG2oZUd0XFtGPKwhXH">
            </baidu-map>
         -->

    </el-main>
  </el-container>
</template>


<script>

import {MP} from '../../../method/baiduMap.js'
import BaiduMap from 'vue-baidu-map/components/map/Map.vue'

export default {
  name: "CompanyMap",
  components: {BaiduMap},
  data() {
    return {
      queryParam: {zoom: 15, lng: 121.165, lat: 31.297},
      map:{},
      center: {lng: 121.165, lat: 31.297},
      zoom: 3,
      companyList: [],
      addData: {parentId: '', name: ''},
      searchKey: '',
    }
  },
  provide() {
    return {
      $fn: {
        afterSearchCompany: (a, b) => {
          this.afterSearchCompany(a, b);
        },
        searchCompany: () => {
          this.searchCompany();
        }
      }
    }
  },
  methods: {
    handler ({BMap, map}) {
      console.log(BMap, map)
      this.center.lng = 118
      this.center.lat = 33
      this.zoom = 15
    },
    setQueryParam(){
      this.queryParam.zoom = this.map.getZoom();

      var cen = this.map.getCenter(); // 获取地图中心点
      this.queryParam.lng = cen.lng.toFixed(5);
      this.queryParam.lat = cen.lat.toFixed(5);
    },
    async searchCompany() {
      console.log("searchCompany===")
      this.setQueryParam();
      //console.log(this.$refs.queryForm.formInfo)

      this.$refs.queryForm.formInfo.zoom = this.queryParam.zoom;
      this.$refs.queryForm.formInfo.lng = this.queryParam.lng;
      this.$refs.queryForm.formInfo.lat = this.queryParam.lat;

      console.log(this.$refs.queryForm.formInfo)

      //查询数据
      this.companyList = await this.$http('companyService.searchCompanyMap', this.$refs.queryForm.formInfo)
      this.setOverlays();

    },
    //这个没用上
    async afterSearchCompany(a, rtnData) {
      console.log("afterSearchCompany===")
      console.log(a)
      console.log(rtnData)
      this.companyList = rtnData.data;

      this.setOverlays();
    },
    setOverlays(){
      this.map.clearOverlays();
      var zoom = this.map.getZoom();

      for(var i=0;i<this.companyList.length;i++){
        var company = this.companyList[i];
        console.log(company.name)

        this.addOverLayMarker(company);
        this.addOverLayLabel(company);
      }
    },
    addOverLayMarker(company){
      var point = new BMapGL.Point(company.map_lng, company.map_lat);
      var myIcon = new BMapGL.Icon("/icons/sales_level_b.png", new BMapGL.Size(32, 32));
      var marker = new BMapGL.Marker(point, {
        color: '#ffff00'
      });
      marker.setStyle({                              // 设置label的样式
        color: '#ffff00'
      })

      var opts = {
        width : 280,     // 信息窗口宽度
        height: 150,     // 信息窗口高度
        title : company.name , // 信息窗口标题
        message:""
      }
      var content = "公司地址：" + company.address_on_map;
      content += "<br>注册金额：" + company.register_amount + company.register_amount_currency;
      content += "<br>注册日期：" + company.register_date;
      content += "<br>参保人数：" + company.insured_number;
      var infoWindow = new BMapGL.InfoWindow(content, opts);  // 创建信息窗口对象
      marker.addEventListener("click", function(){
        this.map.openInfoWindow(infoWindow, point); //开启信息窗口
      });

      this.map.addOverlay(marker);
    },
    addOverLayLabel(company){
      var point = new BMapGL.Point(company.map_lng, company.map_lat);
      var content = company.keyword;
      var label = new BMapGL.Label(content, {       // 创建文本标注
        position: point,                          // 设置标注的地理位置
        offset: new BMapGL.Size(12, -22)           // 设置标注的偏移量
      })
      label.setStyle({                              // 设置label的样式
        color: '#ff0000',
        fontSize: '13px',
        border: 'none'
      })
      this.map.addOverlay(label);
    },
    impMapJs(){
      let script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = '//api.map.baidu.com/api?type=webgl&v=1.0&ak=jOnewmKPxOzITdsLeu5uTbjsHgjrNoYi';
      document.body.appendChild(script);
    },
    initMap(){
      var that = this;
      this.map = new BMapGL.Map('mapContainer');
      this.map.centerAndZoom(new BMapGL.Point(121.165, 31.297), 12);
      this.map.enableScrollWheelZoom(true);
      //隐藏各种图标
      this.map.setDisplayOptions({
        poiIcon: false
      })
      /*
      this.map.setDisplayOptions({
        poiText: false
      })*/

      this.map.addEventListener("zoomend",function () {
        that.searchCompany();
      });

      this.map.addEventListener("moveend",function () {
        that.searchCompany();
      });

      /*
      var content = "测试公司XXXXXXXXXXXXXX";
      var label = new BMapGL.Label(content, {       // 创建文本标注
        position: new BMapGL.Point(121.165, 31.297),                          // 设置标注的地理位置
        offset: new BMapGL.Size(10, 20)           // 设置标注的偏移量
      })
      label.setStyle({                              // 设置label的样式
        color: '#ff0000',
        fontSize: '30px',
        border: '2px solid #1E90FF'
      })
      this.map.addOverlay(label);*/

    }
  },
  created() {
    //this.impMapJs();
  },
  mounted() {
    this.initMap();
  }
}
</script>


<style lang="less" scoped>
@import 'src/global';

.myContainer {
  padding: 5px;
}

.baidu-map-view{
  width: 100%;
  height: 100%;
}

</style>
